"use client";

import { datadogRum } from "@datadog/browser-rum-slim";

datadogRum.init({
  applicationId: "cdc5c58d-b3e6-488a-8184-7b3be961248f",
  clientToken: "pub80b4b87d34ad472aeac9f6b1fdf6bd05",
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: "datadoghq.eu",
  service: "sakani-app",
  env: process.env.NEXT_PUBLIC_APP_ENV,
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: "allow",
});

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
